import React, { useState } from "react";
import "./App.css";
import "@fontsource/roboto/500.css";
import MiNavBar from "../MiNavBar/MiNavBar";
import { Actividades } from "../Actividad/Actividades";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

function App() {
   // if (!token) {
    // return <SingIn setToken={setTokenLocal} />;
  //   return <Actividades />;
  // } else {
    return <MiNavBar />;
  // }
}

export default App;
